import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";

export const Value = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
    valueMapper = (value) => String(value),
}: FormComponentProps) => (
    <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
        {valueMapper(input.value)}
    </Input>
);
